import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { TiUser } from "react-icons/ti";
import { FaFemale, FaMale } from "react-icons/fa";
import { STR_CART_WAS_UPDATED, STR_FEMALE, STR_IMAGE, STR_MALE } from "../Strings";
import { BsChatDots } from "react-icons/bs";
import { MdAdd, MdAddShoppingCart, MdAttachFile, MdLocationPin, MdPlusOne } from "react-icons/md";
import { GiTalk } from "react-icons/gi";
import { IoChatbubble, IoChatbubblesOutline } from "react-icons/io5";
import { BiMinus, BiSolidCartDownload } from "react-icons/bi";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */
	const [quantity, setQuantity] = useState(1);

	function view() {
		appContext.navTo({
			item: 'view',
			subItem: 'pharmacy-item',
			extraItem: data.id,
		})
	}

	function addToCart() {
		appContext.addItemToCart({
			itemId: data.id,
			itemQuantity: quantity,
		});

		appContext.tellInfo(STR_CART_WAS_UPDATED[appContext.language]);
	}

	useEffect(() => {
		//..
	}, [data])

	return (
		<div 
			className="d-flex" 
			
			style={{
				marginTop: "10px",
				marginBottom: "10px",
				border: "1px solid var(--secondaryColor)",
				borderRadius: "10px",
				overflow: "hidden",
				height: "150px"
			}}
		>
			<div 
				className="bg-surface"
				style={{
					width: "150px",
					height: "100%",
					flexShrink: "0",
				}}
				onClick={view}
			>
				<img
					src={CDN_URL+data.photo1}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
					}}
				/>
			</div>

			<div
				style={{
					padding: "10px",
					flexGrow: "1",
					minWidth: "0",
					position: "relative",
				}}
			>
				<h6
					className="mTwoLineText font-semi-bold text-secondary"
					style={{
						fontSize: "16px"
					}}
					onClick={view}
				>
					{data.title}
				</h6>

			
				<h6
					className="text-end mTwoLineText"
					style={{
						fontSize: "18px"
					}}
					onClick={view}
				>
					<span 
						className="font-semi-bold d-block" 
						style={{ 
							fontSize: "12px", 
							textTransform: "uppercase" 
						}}
					>
						<span style={{ fontSize: "12px" }} className="badge bg-dark">{data.unit}</span>
					</span>
					<span style={{ fontSize: "18px" }}>TZS</span> <span className="font-bold">{formatMoney(data.unitPrice)}</span>
					
				</h6>

				<div 
					className="d-flex justify-content-between"
					style={{
						position: "absolute",
						width: "100%",
						padding: "5px",
						bottom: "0",
						left: "0",
					}}
				>

					<div
						className="align-self-center d-flex"
						style={{
							flexShrink: "0",
						}}
					>
						<MdAdd
							className="align-self-center"
							size={24}
							onClick={(e) => {
								e.stopPropagation();
								setQuantity((_prev) => {
									return _prev + 1;
								})
							}}
						/>

						<input
							className="form-control text-center font-bold"
							style={{
								width: "40px",
								fontSize: "12px",
								padding: "2px"
							}}
							value={quantity}
							onChange={(e) => {
								if(!isNaN(Number(e.target.value)) && Number(e.target.value) > 0) {
									setQuantity(Number(e.target.value))
								}
							}}
							onClick={(e) => {
								e.stopPropagation();
							}}
						/>

						<BiMinus
							className="align-self-center"
							size={24}
							onClick={(e) => {
								e.stopPropagation();
								setQuantity((_prev) => {
									if(_prev - 1 > 0) {
										return _prev - 1;
									} else {
										return _prev;
									}
								})
							}}
						/>
					</div>

					<BiSolidCartDownload
						className="align-self-center text-secondary"
						size={36}
						onClick={addToCart}
					/>
				</div>

			</div>
		</div>
	)
}
